import { configureStore } from "@reduxjs/toolkit";
import SettingsReducer from "../reducers/siteSettings";
import ThemeReducer from "../reducers/slices/themeSlice";
import sbgDetailsreducer from "../reducers/sbgDetails";
import homereducer from "../redux/reducers/homereducer";
import ophRefreshReducer from "../reducers/slices/ophRefreshSlice";

const store = configureStore({
  reducer: {
    settings: SettingsReducer,
    theme: ThemeReducer,
    home: homereducer,
    ophDataRefresh: ophRefreshReducer,
  },
});

export default store;
